import React from 'react';

interface QuantityBadgeProps {
  quantity: number;
}

export function QuantityBadge({ quantity }: QuantityBadgeProps) {
  if (quantity === 0) return null;

  let bgColor = 'bg-gray-100 text-gray-600';
  if (quantity >= 3) {
    bgColor = 'bg-purple-100 text-purple-600';
  } else if (quantity === 2) {
    bgColor = 'bg-blue-100 text-blue-600';
  }

  return (
    <span className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium ${bgColor}`}>
      {quantity}x
    </span>
  );
} 